module.exports = __webpack_public_path__ + "static/assets/51bfec35b203e8348fa4645fb54eb0c4.svg";